// Runtime configuration loader
// Reads environment variables from window.__RUNTIME_CONFIG__ (set by /env.js)
// Falls back to process.env for local development with npm start

const runtimeConfig =
  typeof window !== "undefined" ? window.__RUNTIME_CONFIG__ || {} : {};

const getConfigValue = (key, fallback = "") => {
  const value = runtimeConfig[key];
  if (typeof value === "string" && value.trim() !== "") {
    return value;
  }
  return fallback;
};

// API and URL configuration
export const API_URL = getConfigValue(
  "REACT_APP_API_URL",
  process.env.REACT_APP_API_URL || "",
);

export const IMAGE_DECHARGE_URL = getConfigValue(
  "REACT_APP_IMAGE_DECHARGE_URL",
  process.env.REACT_APP_IMAGE_DECHARGE_URL || "",
);

export const CURRENT_URL = getConfigValue(
  "REACT_APP_CURRENT_URL",
  process.env.REACT_APP_CURRENT_URL || "",
);

// Log error if critical config is missing
if (!API_URL) {
  console.error(
    "Missing runtime config values. Check /env.js generation and environment variable injection.",
  );
}
